import React, { useState } from "react";

import "./styles.less";
import classnames from "classnames";
import ScrollMenu from "react-horizontal-scrolling-menu";
const scrollIntoView = require("scroll-into-view");

export const SolutionSceneBanner = (props) => {
  //   const { t } = useTranslation();

  const { title, subtitle, imgurl, navList, navType = "normal" } = props;
  const [type, setType] = useState(navList[0]?.key);
  const [selected, setSelected] = useState(navList[0]?.key);

  const handleScroll = (id) => {
    setType(id);
    const el = document.querySelector(`#${id}`);
    scrollIntoView(el, {
      time: 300,
      align: {
        top: 0,
        topOffset: 70,
      },
    });
  };

  const onSelect = (key) => {
    setSelected(key);
    handleScroll(key);
  };

  const MenuItem = ({ text, selected }) => {
    return <div className={`menu-item ${selected ? "active" : ""}`}>{text}</div>;
  };

  const Menu = (list, selected) =>
    list.map((el) => {
      const { label, key } = el;
      return <MenuItem text={label} key={key} selected={selected} />;
    });

  const Arrow = ({ text, className }) => {
    return <div className={className}>{text}</div>;
  };

  const ArrowLeft = Arrow({ text: <i className="icon authing-icon authing-jinru"></i>, className: "arrow-prev" });
  const ArrowRight = Arrow({ text: <i className="icon authing-icon authing-jinru"></i>, className: "arrow-next" });

  const menu = Menu(navList, selected);

  return (
    <>
      <section>
        <div className="solution-scene-banner-warp">
          <div className="solution-scene-banner">
            <div className="banner-img">
              <img src={imgurl} alt="authing icon" />
            </div>
            <div className="scene-banner-content">
              <div className="scene-banner-title">{title}</div>
              <div className="scene-banner-subtitle">{subtitle}</div>
            </div>
          </div>
        </div>
      </section>
      {navType === "scroll" && (
        <section className="scroll-navList">
          <ScrollMenu
            data={menu}
            arrowLeft={ArrowLeft}
            arrowRight={ArrowRight}
            selected={selected}
            onSelect={onSelect}
            alignCenter={false}
            wheel={false}
          />
        </section>
      )}
      {navType === "normal" && (
        <section>
          <div className="scene-type">
            {navList?.map((nav) => {
              const cls = classnames({
                item: true,
                selected: type === nav.key,
              });
              return (
                <span
                  onClick={() => {
                    handleScroll(nav.key);
                  }}
                >
                  <div className={cls}>
                    <div className="item-icon">
                      <i className={nav.icon}></i>
                    </div>
                    {nav.label}
                  </div>
                </span>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
};
